<div class="overflow-hidden parent-container d-flex align-items-center justify-content-center flex-column clr-grey">
  <div class="stepper d-flex align-items-center justify-content-between">
    <div *ngFor="let step of steps; let i = index" [class.active]="currentStep === i + 1"
         [class.justify-content-start]="i == steps.length - 1" class="step d-flex align-items-center justify-content-center">
      <div class="d-flex align-items-center circle-label">
        <div class="circle">{{ i + 1 }}</div>
        <span class="label">{{ step }}</span>
      </div>
      <div *ngIf="i < steps.length - 1" class="line"></div>
    </div>
  </div>
  <div class="px-4 py-5 shadow-lg field-container">
    <!-- Header Section -->
    <div class="d-flex justify-content-center align-items-center mb-6 w-100">
      <div class="icon-container d-flex align-items-center justify-content-center">
        <svg fill="none" height="36" viewBox="0 0 36 36" width="36" xmlns="http://www.w3.org/2000/svg">
          <rect fill="#04A2EC" fill-opacity="0.1" height="36" rx="18" width="36"/>
          <rect fill="#D9D9D9" height="17" rx="1.5" stroke="url(#paint0_linear_3079_45703)" width="13" x="11.5"
                y="9.5"/>
          <path d="M14.5 24C14.5 23.7239 14.7239 23.5 15 23.5H21C21.2761 23.5 21.5 23.7239 21.5 24V26.5H14.5V24Z"
                fill="#D9D9D9" stroke="url(#paint1_linear_3079_45703)"/>
          <defs>
            <linearGradient gradientUnits="userSpaceOnUse" id="paint0_linear_3079_45703" x1="10.3212" x2="27.7502" y1="9.17647"
                            y2="10.1756">
              <stop stop-color="#230860"/>
              <stop offset="1" stop-color="#00B6FF"/>
            </linearGradient>
            <linearGradient gradientUnits="userSpaceOnUse" id="paint1_linear_3079_45703" x1="13.6121" x2="23.3918" y1="23.0392"
                            y2="24.4809">
              <stop stop-color="#230860"/>
              <stop offset="1" stop-color="#00B6FF"/>
            </linearGradient>
          </defs>
        </svg>
      </div>
    </div>

    <h1 class="mb-2">Tell us about your business</h1>
    <p class="mb-6">
      Please provide information about your business to help us customize your experience.
    </p>

    <!-- Business Type Input -->
    <form>
      <div class="relative">
        <div class="input-wrapper">
          <div class="input-icon">
            <i class="lucide lucide-building h-5 w-5 text-gray-400"></i>
          </div>
          <mat-form-field appearance="outline" class="location-field w-100">
            <input (ngModelChange)="determineWebsiteType(businessForm.value)" [formControl]="businessForm" [matAutocomplete]="auto1" matInput
                   placeholder="Enter Business type" type="text"/>
            <button (click)="businessForm.setValue('')" *ngIf="businessForm.value" class="clear-button">
              <i class="lucide lucide-x h-5 w-5"></i>
            </button>
            <mat-autocomplete #auto1="matAutocomplete">
              <mat-option (click)="selectBusinessType(option)"
                          (keyup.enter)="selectBusinessType(option)" *ngFor="let option of filteredIndustries | async; index as i"
                          [value]="option.name" id="searchValue">
                {{ option.name | titlecase }}
              </mat-option>
            </mat-autocomplete>
          </mat-form-field>
        </div>
      </div>

      <!-- Website Type Selection -->
      <div *ngIf="businessForm.value"
           class="mt-4 py-2 middle-container d-flex flex-column justify-content-center">
        <p class="text-sm text-gray-700 mb-3">
          Please select the type of website you need:
        </p>

        <div class="d-flex btn-container align-items-center justify-content-center">
          <button (click)="handleWebsiteTypeClick('E_COMMERCE')" [ngClass]="{
                'active-btn': websiteType === 'E_COMMERCE',
                'normal-btn': websiteType !== 'E_COMMERCE'
              }" class="website-option-btn" disabled type="button">
            <i class="lucide lucide-store mr-2 h-4 w-4"></i>
            E-commerce
          </button>

          <button (click)="handleWebsiteTypeClick('STATIC')" [ngClass]="{
                'active-btn': websiteType === 'STATIC',
                'normal-btn': websiteType !== 'STATIC'
              }" class="website-option-btn" disabled type="button">
            <i class="lucide lucide-info mr-2 h-4 w-4"></i>
            Informative
          </button>
        </div>

        <p class="text-xs text-gray-500 mt-3">
          Select the option that best fits your business needs.
        </p>
      </div>
      <div class="d-flex justify-content-center align-items-center mt-5 next-btn-container">
        <button (click)="storeBDetails()" [disabled]="!selectedIndustry.subIndustryId" [ngClass]="{
            'cursor-not-allowed': !selectedIndustry.subIndustryId
          }" class="next-btn" type="submit">
          Next
          <i class="lucide lucide-arrow-right ml-2 h-4 w-4"></i>
        </button>
      </div>
    </form>
  </div>
</div>
